export default __webpack_public_path__ + "static/media/icon_stars_vector.81339426.svg";